import {
  Box,
  Typography,
  Button,
  Paper,
  Avatar,
  Grid,
  Divider,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import axios from "axios";
import DashboardHeader from "../../Dashboard/DashboardHeader";
import { Platform } from "../../Utils/Const";
import api from "../../Utils/Api";

export default function KycuserDetails() {
  const location = useLocation();
  const data = location.state;

  const handleProceed = async () => {
    try {
      const mobile = sessionStorage.getItem("mobileNumber");

      const res = await api.post(
        "https://staging.transactionanalysts.com:444/VCIP/vcip/AccountHolder/GetVerificationStatus",
        {
          mobileNumber: mobile,
          EntityID: 65,
          platformId: Platform,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Company-Code": "TA001",
          },
        }
      );

      const url = res.data?.data?.url;

      if (url) {
        window.location.href = url;
      } else {
        alert("KYC URL not available ❌");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong ❌");
    }
  };

  if (!data) return <Typography>No Data</Typography>;

  const formatDob = (dob) => {
    return dob?.split("T")[0].split("-").reverse().join("-");
  };

  return (
    <>
      <DashboardHeader />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f4f6fb",
          p: 2,
        }}
      >
        <Paper
          elevation={4}
          sx={{
            width: "100%",
            maxWidth: 500,
            p: 3,
            borderRadius: 4,
          }}
        >
          {/* HEADER */}
          <Typography
            variant="h5"
            fontWeight="bold"
            textAlign="center"
            mb={2}
          >
            KYC Details
          </Typography>

          {/* AVATAR */}
          <Box display="flex" justifyContent="center" mb={2}>
            <Avatar
              src={`data:image/jpeg;base64,${data.photoBase64}`}
              sx={{
                width: 90,
                height: 90,
                boxShadow: 3,
              }}
            />
          </Box>

          <Divider sx={{ mb: 2 }} />

          {/* DETAILS */}
          <Grid container spacing={2}>
            {[
              { label: "Aadhaar", value: data.poa },
              { label: "Name", value: data.poiname },
              { label: "DOB", value: formatDob(data.poidob) },
              { label: "Gender", value: data.poigender },
              { label: "Care Of", value: data.poaco },
              { label: "Locality", value: data.poaloc },
              { label: "District", value: data.poadist },
              { label: "State", value: data.poastate },
              { label: "Pincode", value: data.poapc },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Typography
                  sx={{
                    fontSize: 12,
                    color: "#6b7280",
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: "#111827",
                    wordBreak: "break-word",
                  }}
                >
                  {item.value || "-"}
                </Typography>
              </Grid>
            ))}
          </Grid>

          {/* BUTTON */}
          <Box textAlign="center" mt={4}>
            <Button
              variant="contained"
              onClick={handleProceed}
              sx={{
                textTransform: "none",
                px: 5,
                py: 1,
                borderRadius: 3,
                fontWeight: 600,
                background:
                  "linear-gradient(135deg, #83e76a, #78e872)",
              }}
            >
              Proceed to Video KYC
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
}